import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetAutomationDetailRequestDto } from "../../dtos/get-automation-detail-request-dto";
import type { GetAutomationDetailResponseDto } from "../../dtos/get-automation-detail-response-dto";
import { AutomationQueryKeys } from "../../generators/automation-query-keys";
import { AutomationService } from "../../services/automation-service";

type UseGetAutomationDetailQueryParams = {
  queryParams: GetAutomationDetailRequestDto;
  options?: Omit<UseQueryOptions<GetAutomationDetailResponseDto>, "queryKey">;
};

export const useGetAutomationDetailQuery = ({
  queryParams,
  options
}: UseGetAutomationDetailQueryParams) => {
  return useQuery({
    queryKey: AutomationQueryKeys.getAutomationDetail(queryParams.id).queryKey,
    queryFn: async () =>
      await AutomationService.getAutomationDetail({ payload: queryParams }),
    ...options
  });
};
